import React from 'react';
import PlayArrow from '@material-ui/icons/PlayArrow';
import Stop from '@material-ui/icons/Stop';
import Refresh from '@material-ui/icons/Refresh';
import { ActionMenu } from '../../ActionMenu';
import {
  AzureActionMenuItems,
  AzureVmAction,
  VmssAction,
  AzureActionType,
  AzureResourceType,
} from './types';

interface AzureMenuProps {
  handleActionClick: (
    action: AzureActionType,
    service: AzureResourceType,
  ) => void;
  handleMenuClose: () => void;
  handleOpenConnection: () => void;
  menuPosition: { mouseX: number | null; mouseY: number | null };
  service: AzureResourceType;
}

const getMenuItems = (service: AzureResourceType): AzureActionMenuItems[] => {
  switch (service) {
    case 'vm': {
      return [
        {
          action: AzureVmAction.START,
          service: 'vm',
          icon: <PlayArrow fontSize="small" color="primary" />,
          text: 'Start Azure VMs',
          disabled: false,
        },
        {
          action: AzureVmAction.STOP,
          service: 'vm',
          icon: <Stop fontSize="small" color="secondary" />,
          text: 'Stop Azure VMs',
          disabled: false,
        },
        {
          action: AzureVmAction.RESTART,
          service: 'vm',
          icon: <Refresh fontSize="small" color="primary" />,
          text: 'Restart Azure VMs',
          disabled: false,
        },
      ];
    }
    case 'vmss': {
      return [
        {
          action: VmssAction.START,
          service: 'vmss',
          icon: <PlayArrow fontSize="small" color="primary" />,
          text: 'Start VMSS',
          disabled: false,
        },
        {
          action: VmssAction.STOP,
          service: 'vmss',
          icon: <Stop fontSize="small" color="secondary" />,
          text: 'Stop VMSS',
          disabled: false,
        },
        {
          action: VmssAction.RESTART,
          service: 'vmss',
          icon: <Refresh fontSize="small" color="primary" />,
          text: 'Restart VMSS',
          disabled: false,
        },
      ];
    }
    default:
      return [];
  }
};

export const AzureActionMenu: React.FC<AzureMenuProps> = ({
  handleActionClick,
  handleMenuClose,
  menuPosition,
  service,
}) => {
  const menuItems = getMenuItems(service);

  return (
    <ActionMenu<{
      action: AzureActionType;
      service: AzureResourceType;
    }>
      handleActionClick={handleActionClick}
      handleMenuClose={handleMenuClose}
      menuPosition={menuPosition}
      menuItems={menuItems}
    />
  );
};
